'use client'

import { useState, useEffect } from 'react'
import { Input } from "@/components/ui/input"
import { Button } from "@/components/ui/button"
import { Search, X } from "lucide-react"

interface SearchFilterProps {
  placeholder?: string
  onSearch: (query: string) => void
  className?: string
  value?: string
  onChange?: (value: string) => void
}

export function SearchFilter({ placeholder = "Search...", onSearch, className = "", value, onChange }: SearchFilterProps) {
  const [internalQuery, setInternalQuery] = useState('')
  
  // Use controlled value if provided, otherwise use internal state
  const query = value !== undefined ? value : internalQuery
  const setQuery = onChange || setInternalQuery

  useEffect(() => {
    const debounceTimer = setTimeout(() => {
      onSearch(query)
    }, 300)

    return () => clearTimeout(debounceTimer)
  }, [query, onSearch])

  const handleClear = () => {
    setQuery('')
  }

  return (
    <div className={`relative ${className}`}>
      <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-muted-foreground" />
      <Input
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        placeholder={placeholder}
        className="pl-10 pr-10"
      />
      {query && (
        <Button
          variant="ghost"
          size="sm"
          className="absolute right-1 top-1/2 transform -translate-y-1/2 h-6 w-6 p-0"
          onClick={handleClear}
        >
          <X className="h-3 w-3" />
        </Button>
      )}
    </div>
  )
}